import { useEffect, useRef, useState } from 'react'
import lottie from 'lottie-web'
import mtrxLoadingData from '../../assets/images/mtrx-loading.json'

// Minimum time the overlay stays up, so a fast response does not flash it.
const MIN_DISPLAY_MS = 750

/**
 * Full-screen loading cue: the MTRX Lottie animation over a dimmed screen.
 * A hooks port of the admin portal's commons/LoadingOverlay (same animation
 * asset, same styles, same minimum display time) so both portals feel the same.
 */
const LoadingOverlay = ({ show }) => {
	const containerRef = useRef(null)
	const animationRef = useRef(null)
	const shownAtRef = useRef(0)
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		if (show) {
			shownAtRef.current = Date.now()
			setVisible(true)
			return undefined
		}
		if (!visible) return undefined
		const remaining = MIN_DISPLAY_MS - (Date.now() - shownAtRef.current)
		if (remaining <= 0) {
			setVisible(false)
			return undefined
		}
		const timer = setTimeout(() => setVisible(false), remaining)
		return () => clearTimeout(timer)
	}, [show, visible])

	useEffect(() => {
		if (!visible || !containerRef.current) return undefined
		animationRef.current = lottie.loadAnimation({
			container: containerRef.current,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: mtrxLoadingData,
		})
		return () => {
			if (animationRef.current) {
				animationRef.current.destroy()
				animationRef.current = null
			}
		}
	}, [visible])

	if (!visible) return null
	return (
		<div className='loading'>
			<div className='lottie-loader' ref={containerRef} />
		</div>
	)
}

export default LoadingOverlay
